const Dashboard = () => {
  return <div>Dashboard Content</div>;
};

export default Dashboard;
